export default __webpack_public_path__ + "static/media/tiger_4.920a5634.mp3";